import React, { useRef, useState, useCallback, useMemo } from 'react';
import { Modal } from 'bootstrap';

const MODAL_TYPES = {
  EMAIL: 'email',
  OTP: 'otp',
  PROFILE: 'profile'
};

const useModalManager = () => {
  const emailModalRef = useRef(null);
  const otpModalRef = useRef(null);
  const profileModalRef = useRef(null);
  
  const [currentModal, setCurrentModal] = useState(null);
  const [userEmail, setUserEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const modalRefs = useMemo(() => ({
    [MODAL_TYPES.EMAIL]: emailModalRef,
    [MODAL_TYPES.OTP]: otpModalRef,
    [MODAL_TYPES.PROFILE]: profileModalRef
  }), []);

  const closeAllModals = useCallback(() => {
    Object.values(modalRefs).forEach(ref => {
      const modalInstance = Modal.getInstance(ref.current);
      if (modalInstance) modalInstance.hide();
    });
    setCurrentModal(null);
  }, [modalRefs]);

  const openModal = useCallback((modalType) => {
    closeAllModals();
    
    setTimeout(() => {
      const modalRef = modalRefs[modalType];
      if (modalRef?.current) {
        const modal = new Modal(modalRef.current);
        modal.show();
        setCurrentModal(modalType);
      }
    }, 150);
  }, [modalRefs, closeAllModals]);

  return {
    modalRefs,
    currentModal,
    userEmail,
    setUserEmail,
    isLoading,
    setIsLoading,
    openModal,
    closeAllModals
  };
};

export default useModalManager